<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 col-md-12" *ngIf="Vendor.VendorName == 'CART'">
  <form #df="ngForm" novalidate (keydown.enter)="onSubmitFoirCart()" class="formborder col-md-12 mt-2">
    <div class="col-md-12 row">
      <div class="col-md-3 p-0">
        <span class="required-lable">Customer</span>
        <!-- (change)="changeCustomer()" -->
        <select name="CustomerId" id="CustomerId" required placeholder="Select Customer Name" [(ngModel)]="CustomerId"
          class="form-control input-text-css" #refCustomerId="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refCustomerId.invalid,
            'alert-warning':
              refCustomerId.invalid &&
              (refCustomerId.dirty ||
                refCustomerId.touched ||
                refCustomerId.untouched)
          }">
          <option value="">Select Customer</option>
          <option *ngFor="let customer of CustomerList" [value]="customer.CustomerId">
            {{ customer.Customer }} ({{
            customer.Customer_Type == "H"
            ? "Borrower"
            : customer.Customer_Type == "C"
            ? "Co-Borrower"
            : "Guarantor"
            }})
          </option>
        </select>
      </div>

      <div class="col-md-3">
        <span class="required-lable">Bank Name</span>
        <select name="bankNameFoirCart" id="bankNameFoirCart" [(ngModel)]="bankNameFoirCart"
          class="form-control input-text-css" disabled required>
          <option value="other">Other</option>
        </select>
      </div>

      <div class="col-md-3">
        <span class="required-lable">File No.</span>
        <input name="fileNoFoirCart" [(ngModel)]="fileNoFoirCart" id="fileNoFoirCart" placeholder="File No."
          class="form-control input-text-css" disabled required />
      </div>
      <div class="col-md-3">
        <span class="required-lable">Product Type:</span>
        <select required name="productTypeFoirCart" id="productTypeFoirCart" #refproductTypeFoirCart="ngModel"
          [(ngModel)]="productTypeFoirCart" class="form-control input-text-css">
          <option value="salariedLoan">Salaried Loan</option>
          <option value="businessLoan">Business Loan</option>
        </select>
      </div>
      <div class="col-md-3 p-1">
        <span class="required-lable">Bank Statement Upload</span>

        <p class="mt-1">
          <i class="fa fa-upload fileUpload" *ngIf="DocName == ''" (click)="docFile.click()" aria-hidden="true"
            style="cursor: pointer"></i>

          <ng-container *ngIf="DocName">
            <span>
              {{ DocName }}
            </span>
            <i class="fa fa-times ml-2 fs-16" aria-hidden="true" style="cursor: pointer"
              (click)="removeFileFoir(docFile)"></i>
          </ng-container>
        </p>

        <input #docFile type="file" style="display: none" accept=".pdf,.zip"
          (change)="fileChangeListenerFOIR(docFile.files)" />
      </div>

      <div class="col-md-3">
        <span>Password (If required)</span>
        <input type="password" name="passwordFoirCart" [(ngModel)]="passwordFoirCart" id="passwordFoirCart"
          placeholder="Password" class="form-control input-text-css" />
      </div>

      <div class="col-md-6 text-right mt-3">
        <button type="button" (click)="onSubmitFoirCart()" class="btn font-size-12 button-btn"
          [disabled]="!df.form.valid">
          Submit
        </button>
      </div>
    </div>
    <div class="col-md-12 row mt-3">
      <div class="col-md-3" [hidden]="!dataSourceFoirCart">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch" placeholder="What're you searching for?"
                class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
</div>

<div class="row m-0 col-md-12" *ngIf="Vendor.VendorName == 'DIGIO'">
  <form #dff="ngForm" novalidate (keydown.enter)="onSubmitDigioRequest()" class="formborder col-md-12 mt-2">
    <div class="col-md-12 row">
      <div class="col-md-3 p-2">
        <span class="required-lable">Customer</span>
        <!-- (change)="changeCustomer()" -->
        <select name="CustomerIddigio" id="CustomerIddigio" required placeholder="Select Customer Name"
          [(ngModel)]="CustomerId" (ngModelChange)="onCustomerChange($event)" class="form-control input-text-css" #refCustomerId="ngModel" [ngClass]="{
            'is-invalid': dff.submitted && refCustomerId.invalid,
            'alert-warning':
              refCustomerId.invalid &&
              (refCustomerId.dirty ||
                refCustomerId.touched ||
                refCustomerId.untouched)
          }">
          <option value="">Select Customer</option>
          <option *ngFor="let customer of CustomerList" [value]="customer.CustomerId">
            {{ customer.Customer }} ({{
            customer.Customer_Type == "H"
            ? "Borrower"
            : customer.Customer_Type == "C"
            ? "Co-Borrower"
            : "Guarantor"
            }})
          </option>
        </select>
      </div>
       <div class="col-md-3 p-2">
        <span class="required-lable">Select Phone No:</span>
        <select name="CustomerPhoneNo" id="CustomerPhoneNo" required placeholder="Customer Phone No"
          [(ngModel)]="SelectedMobile" class="form-control input-text-css" #refCustomerPhoneNo="ngModel" [ngClass]="{
            'is-invalid': dff.submitted && refCustomerPhoneNo.invalid,
            'alert-warning':
              refCustomerPhoneNo.invalid &&
              (refCustomerPhoneNo.dirty ||
                refCustomerPhoneNo.touched ||
                refCustomerPhoneNo.untouched)
          }">
          <option value="">Select Phone No</option>
          <option *ngFor="let mobile of MobileList" [value]="mobile">
              {{ mobile }}
            </option>            
          
        </select>

      </div>
      
      <div class="col-md-3 p-2">
        <span class="required-lable">Select MSG Type:</span>
        <select [(ngModel)]="ReceiveOn" [(ngModel)]="ReceiveOn"  name="ReceiveOn" id="ReceiveOn"
          class="form-control input-text-css"
          required #refReceiveOn="ngModel" [ngClass]="{
            'is-invalid': dff.submitted && refReceiveOn.invalid,
            'alert-warning':
              refReceiveOn.invalid &&
              (refReceiveOn.dirty ||
                refReceiveOn.touched ||
                refReceiveOn.untouched)
          }">
          <option value="">Select Option</option>
          <option value="SMS">SMS</option>
          <option value="WHATSAPP">WhatsApp</option>
          <!-- <option value="BOTH">SMS + WhatsApp</option> -->
        </select>
      </div>

      <div class="col-md-3 p-2 text-right mt-3">
        <button type="button" (click)="onSubmitDigioRequest()" class="btn font-size-12 button-btn"
          [disabled]="!dff.form.valid">
          Submit Digio
        </button>
      </div>
    </div>
    <div class="col-md-12 row mt-3">
      <div class="col-md-3" [hidden]="!dataSourceFoirCart">
        <form action="" class="search-text">
          <div class="bg-light rounded rounded-pill shadow-sm">
            <div class="input-group">
              <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                name="FilterInputSearch" placeholder="What're you searching for?"
                class="form-control border-0 bg-light" />
              <div class="input-group-append">
                <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </form>
</div>

<div class="row m-0 col-md-12" *ngIf="Vendor.VendorName == 'Unaport'">
  <div class="formborder col-md-12 mt-2">
    <div class="col-md-12 row">
      <div class="col-md-2 p-2">
        <span class="required-lable">Customer</span>
        <select
          name="CustomerIdUnaport"
          id="CustomerIdUnaport"
          [(ngModel)]="CustomerId"
          (ngModelChange)="onCustomerChange($event)"
          class="form-control input-text-css"
        >
          <option value="">Select Customer</option>
          <option *ngFor="let customer of CustomerList" [value]="customer.CustomerId">
            {{ customer.Customer }} ({{
            customer.Customer_Type == "H"
            ? "Borrower"
            : customer.Customer_Type == "C"
            ? "Co-Borrower"
            : "Guarantor"
            }})
          </option>
        </select>
      </div>

      <div class="col-md-2 p-2">
        <span class="required-lable">Select Phone No</span>
        <select
          name="CustomerPhoneNoUnaport"
          id="CustomerPhoneNoUnaport"
          [(ngModel)]="SelectedMobile"
          class="form-control input-text-css"
        >
          <option value="">Select Phone No</option>
          <option *ngFor="let mobile of MobileList" [value]="mobile">
            {{ mobile }}
          </option>
        </select>
      </div>
      <div class="col-md-2 p-2">
        <span class="required-lable">Select Consent Product</span>
        <select
          name="SelectedUnaportProductId"
          id="SelectedUnaportProductId"
          [(ngModel)]="SelectedUnaportProductId"
          class="form-control input-text-css"
        >
          <option value="">Select Product</option>
          
          <option *ngFor="let product of unaportproductList" [ngValue]="product">
            {{ product.product_name }}
          </option>

        </select>
      </div>
      <!-- <div class="col-md-2 p-2">
          <span>Select Organization</span>

          <select
            name="SelectedOrganization"
            id="SelectedOrganization"
            [(ngModel)]="SelectedOrganization"
            class="form-control input-text-css"
          >
            <option [ngValue]="null">Select Organization</option>

            <option *ngFor="let org of organizationList" [ngValue]="org">
              {{ org.label }} - {{ org.entityId }}
            </option>

          </select>
        </div> -->

      <div class="col-md-3 p-2 text-right mt-3">
        <button
          type="button"
          *ngIf="PageAcess && PageAcess[0].Add == 1"
          class="btn font-size-12 button-btn"
          (click)="InitializeSDK()"
          [disabled]="!CustomerId || !SelectedMobile || !SelectedUnaportProductId"
        >
          CREATE CONSENT
        </button>
      </div>
    </div>
  </div>
</div>
<div class="table-responsive" style="margin-top: 10px">
  <mat-table [dataSource]="dataSource" matSort style="height: 60vh; overflow: auto">
    <ng-container matColumnDef="CustomerId">
      <mat-header-cell mat-sort-header class="grid-header" style="max-width: 40px" *matHeaderCellDef>
        #
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 40px; max-height: 5px">
        {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Application_No">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        App No
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Application_No }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Customer_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Customer_Name }}
      </mat-cell>
    </ng-container>
     <ng-container matColumnDef="Customer_Mobile">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Customer Mobile
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Customer_Mobile }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Status">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Status
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Status }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Product_Name">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Product
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Product_Name }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="EmployeeName">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Employee Name
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.EmployeeName }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="CreatedOn">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Created On
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.CreatedOn }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="DocName">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Bank Statement
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <a href="{{ docBaseUrl }}{{ loanSummary.ApplicationNo }}/{{
            row.DocName
          }}" target="_blank">
          <button type="button" class="font-size-12 button-btn" mat-raised-button>
            View
          </button>
        </a>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="View">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Bank Analysis</mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <button *ngIf="row.Status === 'Pending'" type="button" (click)="onSearchPendingStatus(row)"
          class="font-size-12 button-btn" mat-raised-button>
          Run Analysis
        </button>
        <a *ngIf="row.Status != 'Pending'" href="{{ docBaseUrl }}{{ loanSummary.ApplicationNo }}/{{
            row.DocId
          }}.xlsx" target="_blank">
          <!--  <i class="fa fa-eye" style="font-size: large"></i> -->
          <button type="button" class="font-size-12 button-btn" mat-raised-button>
            View
          </button>
        </a>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ViewStatement">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Bank Statement</mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <button *ngIf="row.Status === 'DATA_AVAILABLE'" type="button" (click)="onSearchViewStatement(row)"
          class="font-size-12 button-btn" mat-raised-button>
          View Bank Statement
        </button>
      </mat-cell>
    </ng-container>
     <ng-container matColumnDef="ViewStatementUnaport">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Bank Statement</mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <button *ngIf="row.Status === 'READY'" type="button" (click)="onSearchViewStatementUnaport(row)"
          class="font-size-12 button-btn bankbutton" mat-raised-button>
          View Statement
        </button>
      </mat-cell>
    </ng-container>
    
    <ng-container matColumnDef="ManualFetechUnaportData">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Manual Fetch</mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <button *ngIf="row.consentId && PageAcess && PageAcess[0].Edit == 1" type="button" (click)="ManualFetechUnaportData(row)"
          class="font-size-12 button-btn bankbutton" mat-raised-button>
          Manual Fetch
        </button>
      </mat-cell>
    </ng-container>


    <ng-container matColumnDef="Delete">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Delete
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        <!--    <button type="button"
                 (click)="onDeleteBankStatement(row)"
                 class="font-size-12 button-btn"
                 mat-raised-button>
             Delete
         </button> -->

        <i aria-label="true" class="fa fa-trash style-delete" (click)="onDeleteBankStatement(row)"
          *ngIf="row.Role_Level != 0"></i>
      </mat-cell>
    </ng-container>
    <!-- Header and Row Declarations -->
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <div class="row m-0 align-items-center">
    <div class="col-md-12">
      <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>

<div class="row col-md-12 m-0 mt-2 justify-content-end">
  <button type="button" (click)="next()" class="mt-3 btn font-size-12 button-btn">
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div>
<div style="display: none">
  <span id="digio_doc_id"></span>
  <button type="button" id="RejectClick" class="btn font-size-12 button-btn" (click)="RejectData()">
    Click
  </button>

  <button type="button" id="RefereshClick" class="btn font-size-12 button-btn"
    (click)="getQuickLoan_GetBankStatementAnalysis(0, null, false)">
    Referesh
  </button>
</div>
<!--<button (click)="onSubmit()">Submit111</button>-->

<div class="modal fade in" id="modalOpen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Loan Statement
        </h6>
        <button type="button" (click)="onCloseNPAStatementModel()" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div class="formborder col-md-12 row" style="
            display: flex;
            align-items: center;
            gap: 20px;
            margin-left: 2px;
          ">
          <div class="col-md-2">
            <span> Select Account </span>
            <select name="accountNumber" id="accountNumber" #refaccountNumber="ngModel" [(ngModel)]="selectedAccountId"
              class="form-control input-text-css" required (change)="viewStatement()">
              <option value="">Select Account</option>
              <option *ngFor="let data of accountNumberDrodown" [value]="data.account_id">
                {{ data.account_number }}
              </option>
            </select>
          </div>

          <div class="col-md-12 text-right">

            <button type="button" id="RefereshClick" class="btn font-size-12 button-btn" *ngIf="ShowAnalytics_Data"
              (click)="getShowAnalytics_Data()">
              Download Analytics Data
            </button>
             <button type="button" id="RefereshClick" class="btn font-size-12 button-btn"  *ngIf="selectedrow?.BankStatementData"
              (click)="FifetchExcelDataBySessionId()">
              Fetch Excel Data
            </button>
             <button type="button" id="RefereshClick" class="btn font-size-12 button-btn" *ngIf="selectedrow?.reportIdsArray?.length > 0"
              (click)="FetchAnalyticsData()">
              Fetch Analytics Data
            </button>
            
          </div>
        </div>

        <div style="background-color: white; margin-top: 20px" *ngIf="selectedAccountData && !isUnaport">
          <div class="container">
            <div class="section">Profile</div>

            <p style="margin-top: 5px">
              <span style="font-weight: 600">Type</span>:
              {{ selectedAccountData.fi_data.Account.Profile.Holders.type }}
            </p>
            <table>
              <tr>
                <td style="width: 19%"><b>Address</b></td>
                <td style="width: 30%">
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .address
                  }}
                </td>
                <td style="width: 21%"><b>Dob</b></td>

                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .dob
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Mobile</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .mobile
                  }}
                </td>
                <td><b>Name</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .name
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Nominee</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .nominee
                  }}
                </td>
                <td><b>Landline</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .landline
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Pan</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .pan
                  }}
                </td>
                <td><b>CKYC Compliance</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .ckycCompliance==undefined? selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .ckycRegistered: selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .ckycCompliance
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Email</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data.Account.Profile.Holders.Holder
                  .email
                  }}
                </td>
              </tr>
            </table>
          </div>

          <div class="container">
            <div class="section">Summary</div>

            <table>
              <tr>
                <td><b>Current Balance</b></td>
                <td style="width: 30%">
                  {{
                  selectedAccountData.fi_data?.Account?.Summary
                  ?.currentBalance
                  }}
                </td>
                <td><b>Balance Date Time</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary
                  ?.balanceDateTime
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Type</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.type==undefined?selectedAccountData.fi_data?.Account?.Summary?.accountSubType:selectedAccountData.fi_data?.Account?.Summary?.type
                  }}
                </td>

                <td><b>Account Number</b></td>
                <td>
                  {{ selectedAccountData?.account_number }}
                </td>
              </tr>
              <tr>
                <td><b>Drawing Limit</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.drawingLimit
                  }}
                </td>
                <td><b>Exchange Rate</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.exchgeRate
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Current OD Limit</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary
                  ?.currentODLimit
                  }}
                </td>
                <td><b>Currency</b></td>
                <td>
                  {{ selectedAccountData.fi_data?.Account?.Summary?.currency }}
                </td>
              </tr>
              <tr>
                <td><b>Micr Code</b></td>
                <td>
                  {{ selectedAccountData.fi_data?.Account?.Summary?.micrCode }}
                </td>
                <td><b>Facility</b></td>
                <td>
                  {{ selectedAccountData.fi_data?.Account?.Summary?.facility }}
                </td>
              </tr>
              <tr>
                <td><b>Ifsc Code</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.ifscCode==undefined?selectedAccountData.fi_data?.Account?.Summary?.ifsc:
                  selectedAccountData.fi_data?.Account?.Summary?.ifscCode
                  }}
                </td>
                <td><b>Opening Date</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.openingDate
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Status</b></td>
                <td>
                  {{ selectedAccountData.fi_data?.Account?.Summary?.status }}
                </td>
                <td><b>Transaction Type</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.Pending
                  ?.transactionType
                  }}
                </td>
              </tr>
              <tr>
                <td><b>Amount</b></td>
                <td>
                  {{
                  selectedAccountData.fi_data?.Account?.Summary?.Pending
                  ?.amount
                  }}
                </td>
                <td><b>Branch</b></td>
                <td>
                  {{ selectedAccountData.fi_data?.Account?.Summary?.branch }}
                </td>
              </tr>
            </table>
          </div>

          <div class="transaction-section">
            <div class="section" style="background-color: transparent !important">
              Transaction
            </div>
            <div class="date-range">
              <b>Start Date: </b>
              <span style="margin-right: 10px">
                {{
                selectedAccountData.fi_data.Account.Transactions.startDate
                }}
              </span>
              <b>End Date: </b>
              <span>
                {{
                selectedAccountData.fi_data.Account.Transactions.endDate
                }}
              </span>
            </div>
            <table>
              <tr style="background-color: #cbd5e1 !important">
                <th>Transaction Date</th>
                <th>Reference No</th>
                <th style="text-align: center">Narration</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Balance</th>
                <th>Mode</th>
                <th>Txn Id</th>
              </tr>

              <tr *ngFor="
                  let transactiondata of selectedAccountData.fi_data?.Account
                    ?.Transactions?.Transaction
                ">
                <td>{{ transactiondata.transactionTimestamp }}</td>
                <td>{{ transactiondata.reference }}</td>
                <td>{{ transactiondata.narration }}</td>
                <td>{{ transactiondata.amount }}</td>
                <td>{{ transactiondata.type }}</td>
                <td>{{
                  transactiondata.currentBalance==undefined?transactiondata.transactionalBalance:transactiondata.currentBalance
                  }}</td>
                <td>{{ transactiondata.mode }}</td>
                <td>{{ transactiondata.txnId }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div style="background-color: white; margin-top: 20px" *ngIf="selectedAccountData && isUnaport">

          <!-- 🔹 PROFILE -->
          <div class="container">
            <div class="section">Profile</div>

            <table>
              <tr>
                <td><b>Name</b></td>
                <td>{{ selectedAccountData?.holder_name }}</td>

                <td><b>Mobile</b></td>
                <td>{{ selectedAccountData?.mobile }}</td>
              </tr>

              <tr>
                <td><b>PAN</b></td>
                <td>{{ selectedAccountData?.pan }}</td>

                <td><b>Account Type</b></td>
                <td>{{ selectedAccountData?.account_type }}</td>
              </tr>

              <tr>
                <td><b>IFSC</b></td>
                <td>{{ selectedAccountData?.ifsc }}</td>

                <td><b>Branch</b></td>
                <td>{{ selectedAccountData?.branch }}</td>
              </tr>
            </table>
          </div>

          <!-- 🔹 SUMMARY -->
          <div class="container">
            <div class="section">Summary</div>

            <table>
              <tr>
                <td><b>Account Number</b></td>
                <td>{{ selectedAccountData?.account_number }}</td>

                <td><b>Current Balance</b></td>
                <td>{{ selectedAccountData?.current_balance }}</td>
              </tr>

              <tr>
                <td><b>Bank</b></td>
                <td>{{ selectedAccountData?.bank }}</td>

                <td><b>Account Type</b></td>
                <td>{{ selectedAccountData?.account_type }}</td>
              </tr>
            </table>
          </div>

          <!-- 🔹 TRANSACTIONS -->
          <div class="transaction-section">
            <div class="section" style="background-color: transparent !important">
              Transactions
            </div>

            <table>
              <tr style="background-color: #cbd5e1 !important">
                <th>Date</th>
                <th>Reference</th>
                <th>Narration</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Balance</th>
                <th>Mode</th>
                <th>Txn Id</th>
              </tr>

              <tr *ngFor="let txn of selectedAccountData?.transactions">
                <td>{{ txn?.date }}</td>
                <td>{{ txn?.reference }}</td>
                <td>{{ txn?.narration }}</td>
                <td>{{ txn?.amount }}</td>
                <td>{{ txn?.type }}</td>
                <td>{{ txn?.balance }}</td>
                <td>{{ txn?.mode }}</td>
                <td>{{ txn?.txnId }}</td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-fiu-unaport-sdk #FIUSDK></app-fiu-unaport-sdk> -->
<div class="modal fade" id="fiusdk">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h5>Initating SDK</h5>
        <button class="close" (click)="closeModal()">×</button>
      </div>

      <div class="modal-body text-center">
        <iframe
          *ngIf="safeSdkUrl !== undefined"
          id="fiuSdkFrame"
          title="Unaport SDK"
          width="100%"
          height="600px"
          [src]="safeSdkUrl"
          (error)="onSdkFrameError()"
        ></iframe>

        <div *ngIf="sdkLoadFailed" class="mt-3">
          <p>The SDK could not render inside the embedded frame. Open it directly in the current webview.</p>
          <button type="button" class="btn font-size-12 button-btn" (click)="openSdkDirectly()">
            Open SDK Directly
          </button>
        </div>
      </div>

    </div>
  </div>
</div>
